module.exports = __webpack_public_path__ + "media/metronic/_theme/media/envato/screen2-cb0d085d247e740fa97b8ddeda0b2d68.jpg";